export class FileDownloadHelper {
    public static downloadFile(fileName: string, contentType: string, fileBytes: string) {
        var sampleArr = this.base64ToBloPart(fileBytes);
        this.saveByteArray(fileName, sampleArr, contentType);
    }

    private static saveByteArray(reportName: string, byte: BlobPart, contentType: string) {
        var blob = new Blob([byte as BlobPart], { type: contentType });
        var blob = new Blob([byte as unknown as BlobPart], { type: contentType });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    };

    private static base64ToArrayBuffer(base64: string): Uint8Array {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    private static base64ToBloPart(base64: string): BlobPart {
        const binaryString = window.atob(base64);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        // Return the real ArrayBuffer, which is valid as a BlobPart
        return bytes.buffer;
    }
}